// Wall clock in a competition's own zone -> an instant.
//
// Feeds quote kickoffs in local time with no offset ("2026-03-12 19:20:00" is
// Melbourne's evening, whatever the reader's clock says). server/odds.mjs has
// the same two-pass DST settle, but the engine may not import server code, so
// it lives here too — in the one module that needs it.

const formatters = new Map();

function formatter(timeZone) {
  let f = formatters.get(timeZone);
  if (!f) {
    f = new Intl.DateTimeFormat('en-GB', {
      timeZone,
      hour12: false,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    });
    formatters.set(timeZone, f);
  }
  return f;
}

// How far a zone's wall clock is ahead of UTC at an instant, in ms.
function offsetAt(ms, timeZone) {
  const p = {};
  for (const { type, value } of formatter(timeZone).formatToParts(new Date(ms))) {
    if (type !== 'literal') p[type] = Number(value);
  }
  // en-GB renders midnight as hour 24 of the previous day; Date.UTC rolls it
  // back over, which is the same instant either way.
  const wall = Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second);
  return wall - Math.floor(ms / 1000) * 1000;
}

const LOCAL = /^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{1,2}):(\d{2})(?::(\d{2}))?)?/;

/**
 * "YYYY-MM-DD HH:MM:SS" (or a bare date) read as `timeZone` wall time, as an
 * ISO instant. Null when the text is not a date at all.
 */
export function zonedIso(localDateTime, timeZone) {
  const m = String(localDateTime ?? '').trim().match(LOCAL);
  if (!m) return null;
  const [, y, mo, d, hh = '0', mi = '0', ss = '0'] = m;
  const wall = Date.UTC(Number(y), Number(mo) - 1, Number(d), Number(hh), Number(mi), Number(ss));
  const guess = wall - offsetAt(wall, timeZone);
  return new Date(wall - offsetAt(guess, timeZone)).toISOString();
}
